// eslint-disable-next-line no-restricted-imports
import store from '@/vuex/store';
import { LOAD_STATUS } from '@/vuex/modules/auth/auth.module';

export function setupAnalytics () {
    setupPendoSnippet();
}

export function getPendoSnippetLocation () {
    return process.env.VUE_APP_PENDO_INTERNAL_SNIPPET_DOMAIN;
}

export function getPendoApiKey () {
    return process.env.VUE_APP_PENDO_INTERNAL_API_KEY;
}

export function setupPendoSnippet (snippetLocation = getPendoSnippetLocation(), apiKey = getPendoApiKey()) {
    store.commit('auth/setSegmentFlagsLoadStatus', { status: LOAD_STATUS.PENDING });
    const src = `https://${snippetLocation}/agent/static/${apiKey}/pendo.js`;

    /* eslint-disable */
    // prettier-ignore
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
    v=['initialize','identify','updateOptions','pageLoad','track','trackAgent'];for(w=0,x=v.length;w<x;++w)(function(m){
    o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
    y=e.createElement(n);y.async=!0;y.src = src;
    z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
    /* eslint-enable */

    return true;
}
